module.exports = __webpack_public_path__ + "img/scratch.6cda79d8.png";